/* eslint-disable react/no-array-index-key */
import { Col } from 'react-bootstrap';
import { Select, SelectOption } from 'appkit-react';

const TargetGroupBy = ({
    trgtGroupByList, shouldNotShowTrgtGrpByList, updatedConfigData, targetGroupBy,
    onTargetGroupBy,
}) => (
    <Col>
        <p className="true-comply-datarecon__reconcliationtype-sum__column">GROUP BY</p>
        <div className="true-comply-datarecon__reconcliationtype-sum__select">
            <Select
                placeholder="Select"
                multiple
                onSelect={onTargetGroupBy}
                value={targetGroupBy}
            >
                {trgtGroupByList && trgtGroupByList.length > 0 && trgtGroupByList.map((c, index) => (
                    <SelectOption key={`${c.column}_${index}`} value={c.column}>{c.displayName}</SelectOption>
                ))}
                {shouldNotShowTrgtGrpByList && updatedConfigData[1].selectedColumns
                    .map((c, index) => (
                        <SelectOption key={`${c.column}_${index}`} value={c.column}>{c.displayName}</SelectOption>
                    ))}
            </Select>
        </div>
    </Col>
);

export default TargetGroupBy;
